// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__3Uzbn","buttons":"RemoveExpirationActionButtons_buttons__2YyAf"};